/**
 * This module allows the enabling and disabling of the bluetooth hardware
 * that is, turning it on and off.
 */

var Model = require("../types/Model.js");

module.exports = new Model({
	name: "bluetoothonoff",

	init: init,
	listeners: listeners,

	enable: enable,
	disable: disable,
});

function init() {
	// Bluetooth is enabled by default
	this.push(true);
}

function listeners() {
	return {
		"mqtt:$/bluetooth/force": force_state,
	};
}

function enable() {
	if (this.data) return;

	this.push(true);

	this.emit("bluetooth:trigger:bluetooth:on", {
		on: true
	});
}

function disable() {
	if (!this.data) return;

	this.push(false);

	this.emit("bluetooth:trigger:bluetooth:off", {
		on: false
	});
}

function force_state(data) {
	var state = data.state;

	if (state)
		this.enable();
	else this.disable();
}
